import React from 'react';

import ArrowDoorOut3 from "./icons/arrow-door-out-3";
import Blockchain3 from "./icons/blockchain-3";
import BoltSlash from "./icons/bolt-slash";
import Add from "./icons/e-add-2";
import AddBold from "./icons/e-add";
import Cogwheel from "./icons/cogwheel";
import Delete from "./icons/e-delete-2";
import DeleteBold from "./icons/e-delete";
import Edit from "./icons/d-edit-2";
import EditBold from "./icons/d-edit";
import Remove from "./icons/e-remove-2";
import RemoveBold from "./icons/e-remove";
import View from "./icons/eye-open";
import Hide from "./icons/eye-closed";
import RightChevron from "./icons/chevron-right";
import LeftChevron from "./icons/chevron-left";
import UpChevron from "./icons/chevron-up";
import DownChevron from "./icons/chevron-down";
import DragHand from "./icons/hand";
import Image from "./icons/image";
import Link from "./icons/link";
import Search from "./icons/magnifier";
import OrderedList from "./icons/ordered-list";
import FileContent from "./icons/file-content";
import Folder from "./icons/folder";
import DataUpload from "./icons/data-upload-2";
import ChartBar from "./icons/chart-bar-trend-up";
import GridInterface from "./icons/grid-interface";
import HalfDottedCirclePlay from "./icons/half-dotted-circle-play";
import Paragraph from "./icons/paragraph";
import GlobePointer from "./icons/globe-pointer";
import UnorderedList from "./icons/unordered-list";
import WindowPointer from "./icons/window-pointer";
import Users from "./icons/users";
import Chat from "./icons/chat";
import Send from "./icons/send";
import ShoppingCart from "./icons/shopping-cart";
import Paperclip from "./icons/paperclip";
import Emoji from "./icons/emoji";
import Checkmark from "./icons/checkmark";
import DoubleCheckmark from "./icons/double-checkmark";
import VerticalDots from "./icons/vertical-dots";
import Refresh2 from "./icons/refresh-2";
import Filter from "./icons/filter";
import Sparkle3 from "./icons/sparkle-3";
import Language from "./icons/language";
import Phone from "./icons/phone";
import Facebook from "./icons/facebook";
import Tiktok from "./icons/tik-tok";
import Shop from "./icons/shop";

const iconComponents = {
    arrowDoorOut3: ArrowDoorOut3,
    blockchain3: Blockchain3,
    boltSlash: BoltSlash,
    add: Add,
    addBold: AddBold,
    cogwheel: Cogwheel,
    delete: Delete,
    deleteBold: DeleteBold,
    edit: Edit,
    editBold: EditBold,
    remove: Remove,
    removeBold: RemoveBold,
    search: Search,
    view: View,
    hide: Hide,
    rightChevron: RightChevron,
    leftChevron: LeftChevron,
    upChevron: UpChevron,
    downChevron: DownChevron,
    dragHand: DragHand,
    image: Image,
    link: Link,
    orderedList: OrderedList,
    fileContent: FileContent,
    folder: Folder,
    dataUpload: DataUpload,
    chartBar: ChartBar,
    gridView: GridInterface,
    listView: Paragraph,
    halfDottedCirclePlay: HalfDottedCirclePlay,
    globePointer: GlobePointer,
    unorderedList: UnorderedList,
    windowPointer: WindowPointer,
    chat: Chat,
    send: Send,
    shoppingCart: ShoppingCart,
    paperclip: Paperclip,
    emoji: Emoji,
    checkmark: Checkmark,
    doubleCheckmark: DoubleCheckmark,
    verticalDots: VerticalDots,
    users: Users,
    refresh2: Refresh2,
    filter: Filter,
    sparkle3: Sparkle3,
    language: Language,
    phone: Phone,
    facebook: Facebook,
    tiktok: Tiktok,
    shop: Shop,
};

const Icon = ({ name, size = 18, color, ...props }) => {
    const IconComponent = iconComponents[name];

    if (!IconComponent) {
        console.warn(`Icon "${name}" not found`);
        return null;
    }

    return (
        <IconComponent
            width={size}
            height={size}
            fill={color}
            {...props}
        />
    );
};

export default Icon;